import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";
  import { useScrollDragMobile } from "@/features/useScrollDragMobile";

  import { BuilderInterface } from "@/types/BuilderInterface";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";

  import { ref, computed, watch, Ref, onMounted, onBeforeUnmount } from "vue";

  const buttonWidth = 170;
  interface Props {
    items: ({ id: string } | { _id: string })[];
    selectedItem: { id?: string; _id?: string };
    title: string;
    contentTitle?: string;
    isLogoSwipe?: boolean;
    isHouseSelectSlider?: boolean;
  }

  type Emits = (e: "onSelectItem", value: string | undefined) => void;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseSelectorMobile',
  props: {
    items: {},
    selectedItem: {},
    title: {},
    contentTitle: {},
    isLogoSwipe: { type: Boolean },
    isHouseSelectSlider: { type: Boolean }
  },
  emits: ["onSelectItem"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const step = buttonWidth;

  const props = __props;

  const emits = __emit;

  const scrollOffset = ref(0);
  const buttonsContainer = ref<HTMLElement>();
  const isButtonClicked = ref(false);
  const itemClicked = ref<{ id?: string; _id?: string } | null>(null);

  const { isDesktop } = useIsDesktop(990);
  const { onTouchCancel, onTouchEnd, onTouchMove, onTouchstart } =
    useScrollDragMobile(buttonsContainer as Ref<HTMLElement>);

  const showControls = computed(() => {
    const MAX_ITEMS_WITHOUT_CONTROLS = 5;

    if (checkHasMobileEvents()) return false;

    return (
      props.items.length > MAX_ITEMS_WITHOUT_CONTROLS ||
      canDesktopScrollLeft.value ||
      canDesktopScrollRight.value
    );
  });

  const containerStyles = computed(() => ({
    transform: `translateX(-${scrollOffset.value}px)`,
  }));

  const canDesktopScrollLeft = computed(
    () => scrollOffset.value > 0 && !!buttonsContainer.value
  );

  const canDesktopScrollRight = computed(() => {
    const containerWidth = buttonsContainer.value?.clientWidth ?? 0;
    const contentWidth = buttonsContainer.value?.scrollWidth ?? 0;
    const maxScrollOffset = contentWidth - containerWidth;

    return scrollOffset.value < maxScrollOffset && !!buttonsContainer.value;
  });

  const onSelectItem = (item: { id?: string; _id?: string }) => {
    const idComparison = props.isHouseSelectSlider
      ? props.selectedItem?._id === item._id
      : props.selectedItem?.id === item.id;

    if (idComparison) {
      return;
    }

    emits("onSelectItem", item._id);

    isButtonClicked.value = true;
    itemClicked.value = item;
  };

  const scrollDesktopRight = () => {
    if (canDesktopScrollRight.value) {
      scrollOffset.value += step;
    }
  };

  const scrollDesktopLeft = () => {
    if (canDesktopScrollLeft.value) {
      scrollOffset.value -= step;
    }
  };

  const checkHasMobileEvents = () => {
    const MOBILE_EVENT = "ontouchstart";

    return MOBILE_EVENT in document.documentElement;
  };

  const resetOffsetHandler = () => {
    scrollOffset.value = -1;
    scrollOffset.value = 0;
  };

  watch(
    () => props.items,
    () => {
      scrollOffset.value = 0;
    },
    { deep: true }
  );

  onMounted(() => {
    window.addEventListener("resize", resetOffsetHandler);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", resetOffsetHandler);
  });

const __returned__ = { buttonWidth, step, props, emits, scrollOffset, buttonsContainer, isButtonClicked, itemClicked, isDesktop, onTouchCancel, onTouchEnd, onTouchMove, onTouchstart, showControls, containerStyles, canDesktopScrollLeft, canDesktopScrollRight, onSelectItem, scrollDesktopRight, scrollDesktopLeft, checkHasMobileEvents, resetOffsetHandler, get useIsDesktop() { return useIsDesktop }, get useScrollDragMobile() { return useScrollDragMobile }, get BuilderInterface() { return BuilderInterface }, get HouseDesignInterface() { return HouseDesignInterface }, ref, computed, watch, Ref, onMounted, onBeforeUnmount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})